import { render, staticRenderFns } from "./VoteLog.vue?vue&type=template&id=18b1010c&"
import script from "./VoteLog.vue?vue&type=script&lang=js&"
export * from "./VoteLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports